<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
        &nbsp; / &nbsp;
        <li class="breadcrumb-item active">
          {{ 'general.create' | translate }}
        </li>
      </ol>
    </nav>

    <h1 class="page-header-title">
      {{ 'general.create' | translate }}
      {{ 'role permissions' }}
    </h1>
  </header>
  <!-- End Page Header -->

  <section class="card">
    <div class="card-header">
      <h3 class="card-title">
        {{ 'general.create' | translate }}
        {{ 'role permissions' }}
      </h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-lg-8">
          <role-permissions-form (onSubmit)="onSubmit($event)">
          </role-permissions-form>
        </div>
      </div>
    </div>
  </section>
</div>
